import { ILanguageStrings } from '../utils/languages/languages';

export interface IProductsServicesProps {
  nextStep: Function;
  previousStep: Function;
  handleChange?: Function;
  initialState: IProductsSubmitState;
  cachedResponse?: any;
  isAlreadyTagged?: boolean;
  taggedDate?: string;
  languageStrings: ILanguageStrings;
}

export interface IProduct {
  checked?: boolean;
  itemKey: number;
  description: string;
  nameToAdd?: string;
  child?: IProduct[];
  isExpanded?: boolean;
}

export interface IProductsSubmitState {
  productsAddedList: IProduct[];
  productsList?: IProduct[];
  taggedDate?: string;
}

export interface IProductToSubmit {
  itemKey: number;
  nameToAdd?: string;
}

export interface IProductsServicesState {
  productsList: IProduct[];
  productsListFiltered: IProduct[];
  addedProducts: IProduct[];
  addedProductsFiltered: IProduct[];
  searchText: string;
  flag?: number;
  loading?: boolean;
}

export interface IProductsTagResponse {
  updatedDate: string;
  productList: IProduct[];
}

const ProductsServicesState: IProductsSubmitState = {
  productsAddedList: [],
  productsList: []
};

export default ProductsServicesState;
